import styled from "styled-components";
import Typography from "component/MarketPlace/Typography/Typography";
import HlxButton from "../../commonComponents/button/button";
import { IThemeProps } from "component/theme";

export const StyledTypographyDesc = styled(Typography)`
      @media screen and (min-width: 0px) and (max-width: 900px) {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        text-overflow: ellipsis;
        overflow: hidden;
    };
`;

export const StyledButton = styled(HlxButton)`
  ${({ theme } : IThemeProps) => `
    button {  
      flex-direction: row;
      width: 280px !important; 
      height: 42px !important;
      margin-top: ${theme.uptimeSpace[8]}px;
    };

    @media screen and (min-width: 0px) and (max-width: 900px})  {
      button { 
        width: 144px !important;
        margin-top: ${theme.uptimeSpace[13]}px;
    };
  };
  `}
`;